import { BottomSheet } from "@songtradr-one/components-frontend";
import { PropsMobile } from "./UserMenu.Parts";
import { UserMenuContent } from "./user-menu-content/UserMenuContent";

export const UserMenuMobile = ({
  open,
  onOpenChange,
  subModules,
}: PropsMobile) => (
  <BottomSheet open={open} onOpenChange={onOpenChange} hiddenTitle="User Menu">
    <UserMenuContent onOpenChange={onOpenChange} subModules={subModules} />
  </BottomSheet>
);
